import { useEffect, type ReactNode } from "react";

import i18n from "i18n";

export function LanguageProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.lang = "es-AR";
    i18n.changeLanguage("es");
  }, []);

  return <>{children}</>;
}
